<template>
	<PublicPage :current="`/${pageKey}`" :eyebrow="page.eyebrow" :title="page.title" :lead="page.lead">
		<div v-if="page.fraudCard" class="contact-card fraud-contact">
			<div class="contact-icon"><ShieldCheck :size="30" :stroke-width="1.7" /></div>
			<span>REPORT A CONCERN</span>
			<h2>See a suspicious Paydeck payment?</h2>
			<a href="mailto:121@paydeck.in?subject=Fraud%20report%20-%20Paydeck">121@paydeck.in <ArrowUpRight :size="30" /></a>
			<p>Email us with as much available details, facts, documents, SMS’s and statements as you can.</p>
		</div>
		<PdNotice v-if="page.fraudCard" class="fraud-notice" tone="warning" title="Report early" tag="Safe window">A transaction made on a Monday clears from Paydeck by 12 noon on Tuesday. Reported by 11 AM on Tuesday, it can still be stopped. Once cleared and settled, a refund is no longer possible through Paydeck.</PdNotice>
		<div class="article-intro">
			<span>{{ page.intro.label }}</span>
			<h2>{{ page.intro.heading }}</h2>
			<p v-for="(paragraph, i) in page.intro.paragraphs" :key="i" v-html="linkify(paragraph)" />
			<p v-if="page.intro.meta" class="article-meta">{{ page.intro.meta }}</p>
		</div>
		<ContentSection v-for="(section, i) in page.sections" :key="section.title" :number="String(i + 1).padStart(2, '0')" :title="section.title">
			<template v-for="(block, j) in section.blocks" :key="j">
				<h3 v-if="block.h" class="content-subhead">{{ block.h }}</h3>
				<ul v-else-if="block.list" class="safety-list"><li v-for="(item, k) in block.list" :key="k" v-html="linkify(item)" /></ul>
				<p v-else v-html="linkify(block.p)" />
			</template>
		</ContentSection>
	</PublicPage>
</template>

<script setup>
import { computed } from "vue";
import { ArrowUpRight, ShieldCheck } from "lucide-vue-next";
import PdNotice from "@paydeck-ui/components/PdNotice.vue";
import PublicPage from "@/components/site/PublicPage.vue";
import ContentSection from "@/components/site/ContentSection.vue";
import { legalPages } from "@/content/legal";
import { linkify } from "@/helpers/linkify";

const props = defineProps({ pageKey: { type: String, required: true } });
const page = computed(() => legalPages[props.pageKey]);
</script>
